import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AppSwitch from "./AppSwitch";
import NotificationProvider from "./providers/NotificationProvider";
import ModerationCountProvider from "./providers/ModerationCountProvider";
import GlobalsContext from "./context/GlobalsContext";
import WsContext from "./context/WsContext";
import eventEmitter from "./utils/EventEmitter";
import { WsClient } from "./utils/WsClient";
import { wsHost } from "./config";
import { init } from "./utils/api";
import { Login } from "./views/Auth/Login";
import { ConfigProvider } from "./ConfigProvider";
import { TimeTrackingProvider } from "./context/TimeTrackingContext";

eventEmitter.subscribe("connect", () => {
  console.log("connect");
});

eventEmitter.subscribe("disconnect", () => {
  console.log("disconnect");
});

eventEmitter.subscribe("*", data => {
  console.log(data);
});

const wsClient = new WsClient(eventEmitter, wsHost);

const urlSearchParams = new URLSearchParams(window.location.search);

export default () => {
  const [isLoading, setIsLoading] = useState(true);
  const [globals, setGlobals] = useState(null);

  useEffect(() => {
    let params = {};

    for (const [key, value] of urlSearchParams.entries()) {
      params = {
        ...params,
        [key]: value
      };
    }

    init(params)
      .then(setGlobals)
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (!globals) {
      return;
    }
  }, [globals]);

  if (isLoading) {
    return <div>Загрузка</div>;
  }

  return (
    <Router basename="/app">
      <Switch>
        <Route path={"/auth/login"}>
          <Login />
        </Route>
        {globals && <Authorized globals={globals} />}
      </Switch>
    </Router>
  );
};

const Authorized = ({ globals }) => {
  return (
    <GlobalsContext.Provider value={globals || {}}>
      <ConfigProvider>
        <WsContext.Provider value={{ eventEmitter: eventEmitter }}>
          <NotificationProvider>
            <ModerationCountProvider>
              <TimeTrackingProvider>
                <Route component={AppSwitch} />
              </TimeTrackingProvider>
            </ModerationCountProvider>
          </NotificationProvider>
        </WsContext.Provider>
      </ConfigProvider>
    </GlobalsContext.Provider>
  );
};
